import Resource from '@/api/resources/Resource'

class CaseComprehensiveDiagnosisServices extends Resource {
    async findById(laboratoryId, caseId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/comprehensiveDiagnosis`)
        return response.data
    }
    async updateDescription(laboratoryId, caseId, description) {
        const response = await this.axios.put(`/laboratories/${laboratoryId}/cases/${caseId}/comprehensiveDiagnosis`, description)
        return response.data
    }
    async updateDescriptionAndSolveCodificationsChange(laboratoryId, caseId, description, replaceInsteadOfAdd) {
        const params = { replaceInsteadOfAdd }
        const response = await this.axios.put(`/laboratories/${laboratoryId}/cases/${caseId}/comprehensiveDiagnosis/solveCodificationsChange`, description, { params })
        return response.data
    }
}

export default new CaseComprehensiveDiagnosisServices()
